/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
const mutations = {

  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  UPDATE_SIDEBAR_WIDTH(state, width) {
    state.sidebarWidth = width;
  },
  UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
    state.sidebarItemsMin = val;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
    state.isSidebarActive = value;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_BREAKPOINT(state, val) {
    state.breakpoint = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_USER_ROLE(state, val) {
    state.userRole = val
    localStorage.setItem('userRole', val)
  },
  // UPDATE_STATUS_CHAT(state, value) {
  //     state.AppActiveUser.status = value;
  // },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },


  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index)
    // update the main list
    state.navbarSearchAndPinList.data[index].highlightAction = payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList.data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.index == payload.index)
      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // The Navbar
  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })
    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },
  UPDATE_USER(state, payload) {
    state.userData.AppActiveUser = payload || [];
  },
  UPDATE_COMPANIES(state, payload) {
    state.userData.AppActiveCompanies = payload || [];
  },
  UPDATE_CLIENTS(state, payload) {
    state.userData.AppActiveClients = payload || [];
  },
  UPDATE_LOCATIONS(state, payload) {
    //(payload);
    state.userData.AppActiveLocations = payload || [];
  },
  UPDATE_NEWS(state, payload) {

    state.userData.AppActiveNews = payload || [];
  },
  UPDATE_APPOINTMENTS(state, payload) {
    state.userData.AppActiveAppointments = payload || [];
  },

  //others
  UPDATE_HCF(state, payload) {
    state.hcfInfo = payload;
  },
  UPDATE_HCF_CODELIST(state, payload) {
    state.userData.AppActiveHcfCodelist = payload;
  },
  UPDATE_PHONE_PREFIX(state, payload) {
    state.userData.AppActivePhonePrefixes = payload;
  },
  UPDATE_CODELISTS(state, {
    data,
    payload
  }) {
    state.userData.AppActiveCodelists[payload] = data;
  },

  UPDATE_FILE_IDS(state, payload) {
    state.userData.AppActiveFiles = {
      ...state.userData.AppActiveFiles,
      [payload.idFile]: payload.base
    };
  },

  UPDATE_CACHE(state, payload) {
    state.userData.resCache[payload.res] = new Date(new Date().setSeconds(new Date().getSeconds() + payload.time));
  },
  RESET_STORE(state) {
    localStorage.clear();
    state.userData = {
        AppActiveUser: {},
        AppActiveCompanies: [],
        AppActiveClients: [],
        AppActiveLocations: [],
        AppActiveAppointments: [],
        AppActiveNews: [],
        AppActivePhonePrefixes: [],
        AppActiveHcfCodelist: [],
        AppActiveFiles: {},
        resCache: {},
        AppActiveCodelists: {},
      },
      state.smsFormRestriction = false;
  },
  UPDATE_LANGUAGES(state, payload) {
    state.userData.AppActiveLanguages = payload;

  },
  UPDATE_LANGUAGE(state, payload) {
    state.userData.AppActiveUser.idLanguage = payload.idLanguage;
    state.userData.AppActiveUser.language = payload.code.split('-')[0];
  },
  UPDATE_CREDITS(state, payload) {
    state.userData.AppActiveCredits = payload;
  },
  UPDATE_RESTRICTED(state) {
    state.smsFormRestriction = true;
  },
  UPDATE_SITEKEY(state, payload) {
    state.googleCaptchaSiteKey = payload;
  }
}

export default mutations
